import { supabase } from '../supabaseClient';

export const planService = {
  async getActivePlans() {
    const { data, error } = await supabase
      .from('plans')
      .select('*')
      .eq('is_active', true)
      .order('price', { ascending: true });
    if (error) throw error;
    return data || [];
  },

  async getAllPlansAdmin() {
    const { data, error } = await supabase
      .from('plans')
      .select('*')
      .order('created_at', { ascending: false });
    if (error) throw error;
    return data || [];
  },

  async createPlan(planPayload) {
    const { data, error } = await supabase
      .from('plans')
      .insert([planPayload])
      .select()
      .single();
    if (error) throw error;
    return data;
  },

  async togglePlanStatus(id, currentStatus) {
    const { data, error } = await supabase
      .from('plans')
      .update({ is_active: !currentStatus, updated_at: new Date().toISOString() })
      .eq('id', id)
      .select()
      .single();
    if (error) throw error;
    return data;
  },

  async deletePlan(id) {
    const { error } = await supabase
      .from('plans')
      .delete()
      .eq('id', id);
    if (error) throw error;
  }
};